<template>
    <div>
        <div class="d-flex align-center flex-wrap px-3 pt-2">
            <span class="text-body-2">
                <strong>{{ totais.servidores }}</strong>
                {{ totais.servidores === 1 ? 'servidor' : 'servidores' }}

                <span :class="totais.com_alerta ? 'orange--text text--darken-3' : 'text--secondary'">
                    · {{ totais.com_alerta }} com alerta
                </span>

                <span :class="totais.sem_coleta ? 'red--text' : 'text--secondary'">
                    · {{ totais.sem_coleta }} sem coleta
                </span>
            </span>

            <v-spacer/>

            <v-btn v-if="podeEditar" color="primary" small class="mr-2" @click="$refs.dialog.abrir(null)">
                <v-icon left small>mdi-plus</v-icon>
                Servidor
            </v-btn>

            <v-btn icon :loading="loading" @click="$emit('recarregar')">
                <v-icon>mdi-refresh</v-icon>
            </v-btn>
        </div>

        <div class="px-3 pt-1 text-caption text--secondary">
            Cada servidor é vigiado pelo servidor da API. Se o próprio servidor da API cair,
            ninguém avisa — isso exigiria um observador externo.
        </div>

        <v-row dense class="px-2 pt-2 pb-4">
            <v-col
                v-for="servidor in servidores"
                :key="servidor.host"
                cols="12"
                sm="6"
                md="4"
                lg="3"
            >
                <CardServidor
                    :servidor="servidor"
                    :podeEditar="podeEditar"
                    @abrir="$emit('abrir', $event.host)"
                    @configurar="$refs.dialog.abrir($event)"
                />
            </v-col>

            <v-col v-if="!servidores.length && !loading" cols="12">
                <div class="pa-12 text-center grey--text">
                    <v-icon large color="grey">mdi-server-off</v-icon>
                    <div class="mt-2">Nenhum servidor ativo no registro.</div>
                    <div v-if="podeEditar" class="text-caption">
                        Cadastre o primeiro para começar a acompanhar.
                    </div>
                </div>
            </v-col>
        </v-row>

        <ServidorDialog ref="dialog" @salvo="aoSalvar"/>
    </div>
</template>

<script>
import CardServidor from './CardServidor';
import ServidorDialog from './ServidorDialog';
import { carregarServidores } from './servidores';

export default {
    name: 'PainelFrota',

    components: {
        CardServidor,
        ServidorDialog,
    },

    props: {
        servidores: { type: Array, default: () => [] },
        totais: { type: Object, default: () => ({ servidores: 0, com_alerta: 0, sem_coleta: 0 }) },
        loading: { type: Boolean, default: false },
    },

    computed: {
        podeEditar() {
            return this.checkPermission('zapercontrol_monitoramento_servidores') || this.isDiretor();
        },
    },

    methods: {
        async aoSalvar() {
            await carregarServidores(this.$http, true);
            this.$emit('recarregar');
        },
    },
};
</script>
